/*

  Usage:

  // Page.scss
  @include media-mobile {

    .container {
      @include viewportHeight(min-height, 100);

      // viewportHeight mixin add styles:
      // min-height: 100vh;
      // min-height: calc(var(--vh, 1vh) * 100);
    }
  }

  // Page.js
  const Page = () => {
    useViewportHeight()

    return (
      <div className={s.container}>
        Full height content
      <div>
    )
  }

  A hook is used to fill viewport height by an element.
  It is useful because mobile browsers includes bottom bar to 100vh.

  Example:
    We have a page that should be 100% of the screen height,
    if we just specify its style as `height: 100vh`, the page height
    will be 100% of the viewport + about 60px.

    This hook fix this, because it set property `--vh` to the body
    that equal to 1% of the viewport.

    If browser don't support custom css properties, there is
    fallback to 100vh and all logic will be as usual.
 */

import React from 'react'
import { throttle } from 'lodash'
import { useMedia, useEffect, useCallback, useState, useEventListener } from 'sb-hooks'


const useViewportHeight = () => {
  const { isMobile } = useMedia()
  const [ viewportHeight, setState ] = useState(window.innerHeight * 0.01)

  const setVh = useCallback(throttle(() => {
    const newViewportHeight = window.innerHeight * 0.01

    if (viewportHeight !== newViewportHeight) {
      setState(newViewportHeight)
    }
  }, 150), [ viewportHeight ])

  useEventListener('resize', setVh)

  useEffect(() => {
    if (isMobile) {
      document.body.style.setProperty('--vh', `${viewportHeight}px`)

      return () => {
        document.body.style.removeProperty('--vh')
      }
    }
  }, [ isMobile, viewportHeight ])
}


export default useViewportHeight
